'use client';

import { logout } from '@/actions';
import { useRouter } from 'next/navigation';

interface TLogoutButton {
  children?: React.ReactNode;
}

export const LogoutButton = ({ children }: TLogoutButton) => {
  const router = useRouter();

  const onClick = async () => {
    await logout();
    router.refresh();
  };

  return <span onClick={onClick}>{children}</span>;
};
